import { createSelector } from 'reselect';

const selectProducts = state => state.products;

const selectShop = state => state.shop;

export const selectShoppingData = createSelector(
    [selectProducts],
    products => products.shoppingData
);

// export const selectShoppingDataBasedOnGroup = createSelector(
//   [selectProducts],
//   products => products.filteredItems
// );

export const selectCollections = createSelector(
  [selectShop],
  shop => shop.collections
);

export const selectCollectionsForPreview = createSelector(
  [selectCollections],
  collections =>
    collections ? Object.keys(collections).map(key => collections[key]) : []
);

export const selectCollection = collectionUrlParam =>
  createSelector(
    [selectCollections],
    collections => (collections ? collections[collectionUrlParam] : null)
  );

export const selectIsCollectionFetching = createSelector(
  [selectShop],
  shop => shop.isFetching
);

export const selectIsCollectionsLoaded = createSelector(
  [selectShop],
  shop => !!shop.collections
);

export const selectRootCategoryIndex = createSelector(
  [selectShop],
  shop => shop.rootCategoryIndex
);

export const selectSubCategoryIndex = createSelector(
  [selectShop],
  shop => shop.subCategoryIndex
);